<template>
    <li
        class="house-slider-item"
        :class="{ mobile: isMobile, 'house-sold': soldDate }"
        :title="address"
        @click="openDetail(link, $event)"
    >
        <article>
            <div class="house-imgs">
                <a
                    :href="linkData.href"
                    :target="linkData.target"
                    :aria-label="linkData['aria-label']"
                    :self="linkData.self"
                >
                    <div class="img-mask" v-if="!isShowMask"></div>
                    <img-swiper
                        class="house-preview"
                        :imgNotZoom="imgNotZoom"
                        @change="onPreviewChange"
                        :allImagesJson="previewsJson"
                        :alt="address"
                        dir="width"
                        :errorImg="defHouseImg"
                        :showSwitch="false"
                    >
                        <!-- <span v-if="tour3D" class="house-count">
                            <i class="iconfont icon-3d"></i
                            >{{ $t('md-house.3d') }}</span
                        > -->
                        <div
                            class="house-status-container"
                            v-if="exclusiveTag || tag"
                        >
                            <house-tag
                                theme="v8"
                                v-if="exclusiveTag"
                                v-bind="exclusiveTag"
                            />
                            <house-tag theme="v8" v-bind="tag" v-if="tag" />
                            <span v-if="tour3D" class="house-count">
                                <i class="iconfont icon-3d"></i
                                >{{ $t('md-house.3d') }}</span
                            >
                        </div>
                        <p
                            class="collect"
                            v-if="!soldDate && !widget"
                            @click.stop.prevent="collect"
                        >
                            <span class="icon-fav">
                                <i
                                    class="iconfont icon-heart-fill"
                                    :class="{
                                        active: heartActive || collected
                                    }"
                                ></i>
                                <i
                                    class="iconfont icon-heart"
                                    :class="{
                                        disactive: !(heartActive || collected)
                                    }"
                                ></i>
                            </span>
                        </p>
                        <template v-slot:mask>
                            <house-mask v-if="isShowMask"></house-mask>
                        </template>
                    </img-swiper>
                </a>
            </div>
            <div class="house-info">
                <div class="house-price-wrap">
                    <title-mask v-if="isShowMask"></title-mask>
                    <template v-else-if="soldDate">
                        <no-disclosure
                            class="sold"
                            v-if="!!house.nodisclosureDes || hidePrice"
                            :des="
                                hidePrice
                                    ? $t('md-house.nondisclosure')
                                    : house.nodisclosureDes
                            "
                        ></no-disclosure>
                        <template v-else>
                            <span class="house-sold-price">
                                {{
                                    $ft.trim(showSoldPrice ? soldPrice : price)
                                }}
                            </span>
                            <span
                                class="house-initial-price"
                                v-if="showAllPrice && initialPrice"
                            >
                                {{ $ft.trim(initialPrice) }}
                            </span>
                        </template>
                        <span
                            :class="[
                                'house-trend',
                                trendUp ? 'trend-up' : 'trend-down'
                            ]"
                            v-if="soldDate && showAllPrice && trend"
                        >
                            {{ trend }}
                        </span>
                    </template>
                    <template v-else>
                        <p
                            class="house-price"
                            v-if="house.nodisclosureDes == null"
                        >
                            {{ $ft.trim(price) }}
                        </p>
                        <no-disclosure
                            class="unsold"
                            v-else
                            :des="house.nodisclosureDes"
                        ></no-disclosure>
                    </template>
                    <p class="detail">
                        <span
                            class="item"
                            v-for="item in basic"
                            :key="item.key"
                        >{{ item.text }}</span
                        >
                    </p>
                    <!-- <p class="house-tag">{{ propertyType }}</p> -->
                </div>
                <p class="address" v-if="address">
                    <a
                        :href="linkData.href"
                        :target="linkData.target"
                        :aria-label="linkData['aria-label']"
                        :self="linkData.self"
                    >
                        <i class="iconfont icon-fashion-address"></i>
                        {{ address }}
                    </a>
                </p>
                <div class="house-mls">
                    <p class="house-mls-logo" v-if="mlsLogo">
                        <site-img :src="mlsLogo" dir="height" :size="30" alt="house mls logo" />
                    </p>
                    <div>
                        <p v-if="showMls" class="house-mls-id">
                            {{ $t('md-house.mls', { mlsid }) }}
                        </p>
                        <p
                            class="desc ws-pre-wrap"
                            v-if="provided && !isShowMask"
                        >
                            {{ provided }}
                        </p>
                    </div>
                </div>

                <a
                    class="view-all-listings"
                    v-if="!isMobileSize && moreListing"
                    :href="moreListing.moreLink"
                    :aria-label="moreListing.moreLinkPurpose"
                    rel="noopener noreferrer"
                >{{ moreListing.moreText }}</a
                >
            </div>
        </article>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </li>
</template>
<script>
import Item from '../item';
import ItemForSearch from '../itemForSearch';
export default {
    mixins: [Item, ItemForSearch],
    data: function() {
        return {
            heartActive: false
            // isShowMask: false
        };
    }
};
</script>
<style lang="scss">
.md-house.template8 {
    .house-slider-item {
        display: flex;
        flex-direction: row-reverse;
        > article {
            display: inherit;
            flex-direction: inherit;
            width: 100%;
            height: 100%;
            position: relative;
            border-radius: 20px;
            background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.3) 0%,
                    rgba(0, 0, 0, 0.6) 100%
                ),
                lightgray 50% / cover no-repeat;
        }

        .house-imgs {
            width: 100%;
            height: 100%;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 20px;
                transition: transform 0.3s ease;
                will-change: transform;
            }
            .img-content {
                border-radius: 20px;
                overflow: hidden;
            }
            .img-content:hover {
                img {
                    transform: scale(1.1);
                }
            }
            .house-status-container {
                position: absolute;
                top: 20px;
                left: 30px;
                z-index: 20;
                display: flex;
                align-items: center;
                height: 20px;
                color: #fff;
                font-family: var(--font-normal);
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
            }
            .collect {
                position: absolute;
                right: 30px;
                top: 20px;
                z-index: 20;
                width: 45px;
                height: 45px;
                border-radius: 50%;
                cursor: pointer;
                background-color: rgba(25, 25, 25, 0.5);
                .icon-fav {
                    font-size: 20px;
                    color: #fff;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    .icon-heart-fill {
                        position: absolute;
                        display: none;
                        &.active {
                            display: inline;
                            color: #f0454c;
                        }
                    }
                    .icon-heart {
                        display: none;
                        &.disactive {
                            display: inline;
                        }
                    }
                }
            }
            .house-count {
                // position: absolute;
                // top: 0;
                // right: 0;
                // z-index: 1;
                color: white;
                padding-left: 5px;
                padding-right: 5px;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                display: flex;
                justify-content: center;
                background-color: rgba(0, 0, 0, 0.4);
                border-radius: 2px;
                .iconfont {
                    margin-right: 5px;
                }
            }
            .md-house__mask {
                border-radius: 20px;
                background: rgba(25, 25, 25, 0.7);
                backdrop-filter: blur(4px);
                .mask-lock {
                    width: 48px;
                    height: 48px;
                    line-height: 48px;
                    .icon-lock1 {
                        font-size: 24px;
                        color: #fff;
                    }
                }
                .text.login {
                    font-family: var(--font-normal);
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 17px;
                    letter-spacing: 0px;
                    text-align: center;
                    color: #fff;
                }
            }

            &:hover {
                .img-content {
                    img {
                        transform: scale(1.1);
                    }
                }
            }
        }

        .img-mask {
            border-radius: 20px;
            background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0.3) 0%,
                rgba(0, 0, 0, 0.6) 100%
            );
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }

        .house-info {
            width: calc(100% - 60px);
            border-radius: 20px;
            position: absolute;
            bottom: 30px;
            left: 30px;
            background-color: rgba(255, 255, 255, 0.75);
            filter: drop-shadow(0px 10px 20px rgba(33, 37, 48, 0.5));
            backdrop-filter: blur(2.5px);
            border: 1px solid #fff;
            box-sizing: border-box;
            padding: 20px 24px;
            z-index: 20;
            .house-price-wrap {
                color: #202437;
                font-size: 24px;
                line-height: 24px;
                margin-bottom: 13px;
                display: flex;
                align-items: center;
                flex-direction: row;
                position: relative;
                .house-sold-price {
                    font-family: var(--font-normal);
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 24px;
                }

                .house-initial-price {
                    font-family: var(--font-normal);
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    text-decoration: line-through;
                    margin-left: 10px;
                }

                .house-trend {
                    font-size: 12px;
                    font-family: var(--font-normal);
                    font-weight: 400;
                    padding-left: 10px;

                    &:before {
                        margin-bottom: 1px;
                        margin-right: 4px;
                        content: '';
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border-left: solid 5px transparent;
                        border-right: solid 5px transparent;
                        border-bottom: solid 6px #29cb97;
                    }

                    &.trend-up {
                        color: #29cb97;
                    }

                    &.trend-down {
                        color: #fb4444;

                        &:before {
                            border-top: solid 6px #fb4444;
                            border-bottom: none;
                        }
                    }
                }

                .house-price,
                .hide-price {
                    font-family: var(--font-normal);
                    font-size: 24px;
                    line-height: 24px;
                    cursor: pointer;
                    .link {
                        cursor: pointer;
                        color: var(--color-theme);
                        text-decoration: underline;
                    }
                }
                .house-price {
                    font-weight: 700;
                    color: #202437;
                }
            }

            .detail {
                color: #4a4a60;
                font-family: var(--font-normal);
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-left: 10px;

                .item {
                    position: relative;
                    padding: 0 8px;
                    &:after {
                        content: '.';
                        position: absolute;
                        top: -3px;
                        right: -2px;
                    }

                    &:last-child:after {
                        content: none;
                        position: static;
                    }
                }
            }
            .house-tag {
                font-family: var(--font-normal);
                font-size: 14px;
                font-weight: 400;
                line-height: 17px;
                letter-spacing: 0px;
                text-align: left;
                color: #4a4a60;
                position: absolute;
                right: 0;
            }

            .address {
                font-size: 14px;
                line-height: 14px;
                color: #4a4a60;
                font-family: var(--font-normal);
                font-style: normal;
                font-weight: 400;
                margin-bottom: 12px;
                .icon-fashion-address {
                    font-size: 14px;
                }
            }

            .house-mls {
                display: flex;
                justify-content: flex-start;
                div {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                .house-mls-logo {
                    margin-right: 10px;
                    img {
                        height: 30px;
                        vertical-align: middle;
                    }
                }
                .house-mls-id,
                .desc {
                    color: #4a4a60;
                    font-family: var(--font-normal);
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 16px;
                }
            }
        }

        &.mobile {
            > article {
                border-radius: 10px;
            }
            display: flex;
            flex-direction: row-reverse;
            border-radius: 10px;
            .img-mask {
                border-radius: 10px;
            }
            .house-imgs {
                width: 100%;
                height: 210px;
                border-radius: 10px 10px 0 0;
                position: relative;

                .img-swiper-wrapper {
                    .slot-wraper {
                        overflow: hidden;
                        .house-status-container {
                            left: 15px;
                            top: 15px;
                            display: flex;
                            flex-wrap: wrap;

                            .house-status {
                                margin-bottom: 5px;
                            }
                        }
                    }
                }
                .img-content{
                    border-radius: 10px 10px 0 0;
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 10px 10px 0 0;
                }
                .house-status-container {
                    top: 15px;
                    left: 15px;
                }
                .collect {
                    right: 15px;
                    top: 150px;
                }
                .house-count{
                     margin-bottom: 5px;
                }

                .md-house__mask {
                    border-radius: 10px 10px 0 0;
                    background: rgba(25, 25, 25, 0.7);
                    backdrop-filter: blur(4px);
                    .mask-lock {
                        width: 48px;
                        height: 48px;
                        line-height: 48px;
                        .icon-lock1 {
                            font-size: 24px;
                            color: #fff;
                        }
                    }
                    .text.login {
                        font-family: var(--font-normal);
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 17px;
                        letter-spacing: 0px;
                        text-align: center;
                        color: #fff;
                        p:nth-child(2) {
                            font-size: 12px;
                        }
                    }
                }
            }

            .house-info {
                display: block;
                width: 100%;
                padding: 15px;
                height: 200px;
                box-sizing: border-box;
                background-color: #fff;
                backdrop-filter: blur(2.5px);
                border: 1px solid #fff;
                border-radius: 0 0 10px 10px;
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: 20;
                .house-price-wrap {
                    margin-bottom: 8px;
                    color: #202437;
                    font-family: var(--font-normal);
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 24px;
                    display: block;
                    .house-sold-price {
                        font-family: var(--font-normal);
                        font-weight: 700;
                        font-size: 18px;
                        line-height: 24px;
                    }

                    .house-price,
                    .hide-price {
                        font-size: 18px;
                        line-height: 24px;
                        cursor: pointer;
                        margin-bottom: 8px;
                    }
                    .house-tag {
                        position: static;
                    }

                    .detail {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .detail {
                    color: #4a4a60;
                    font-family: var(--font-normal);
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 17px;
                    margin-bottom: 8px;
                    margin-left: 0;
                    .item:first-child {
                        padding-left: 0;
                    }
                }
                .address {
                    color: #4a4a60;
                    font-family: var(--font-normal);
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 17px;
                    margin-bottom: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .house-mls {
                    display: block;
                    position: absolute;
                    bottom: 15px;
                    left: 15px;
                    right: 15px;
                    .house-mls-logo {
                        margin: 15px 0;
                        img {
                            width: auto;
                            height: 18px;
                            object-fit: contain;
                            vertical-align: middle;
                        }
                    }
                }
            }
        }
    }
}
</style>
